import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { FirmsActions } from 'redux/reducers/firmsReducer';

export const closeTaskModal = (): Action<FirmsActions> => {
  return createAction(FirmsActions.closeTaskModal);
};
